import { specialChars } from "./special";

declare const SF_VERSION: string;
declare const SF_BUILD: string;

export const getBuildVersion = () => ({
  version: `v${SF_VERSION || specialChars.enDash}`,
  build: `v${SF_VERSION}-${SF_BUILD}`,
});
